import addonsAPI from '~/api/addons'
import lookupsAPI from '~/api/lookups'

export default {
  namespaced: true,

  state: () => ({
    allSecclNodes: [],
    secclNodes: [],
    parentNodeIds: [],
    validParentNodes: [],
    nodeIds: [],
    models: [],
    assets: [],
    schemeProducts: [],
    modelsLoading: false,
    secclAddons: ['soderberg', 'seccl', 'octopus_money', 'p1'],
    platformDetail: {},
  }),

  getters: {
    getAllSecclNodes(state) {
      return state.allSecclNodes
    },
    getSecclNodes(state) {
      return state.secclNodes
    },
    getParentNodeIds(state) {
      return state.parentNodeIds
    },
    getValidParentNodes(state) {
      return state.validParentNodes
    },
    getNodeIds(state) {
      return state.nodeIds
    },
    getModels(state) {
      return state.models
    },
    getAssets(state) {
      return state.assets
    },
    getModelsLoading(state) {
      return state.modelsLoading
    },
    getSchemeProducts(state) {
      return state.schemeProducts
    },
    getPlatformDetail(state) {
      return state.platformDetail
    }
  },

  mutations: {
    SET_ALL_SECCL_NODES(state, nodes) {
      state.allSecclNodes = nodes
    },
    SET_SECCL_NODES(state, nodes) {
      state.secclNodes = nodes
    },
    SET_PARENT_NODE_IDS(state, nodeIds) {
      state.parentNodeIds = nodeIds
    },
    SET_VALID_PARENT_NODES(state, nodes) {
      state.validParentNodes = nodes
    },
    SET_NODE_IDS(state, nodeIds) {
      state.nodeIds = nodeIds
    },
    SET_MODELS(state, models) {
      state.models = models
    },
    SET_MODELS_LOADING(state, loading) {
      state.modelsLoading = loading
    },
    SET_ASSETS(state, assets) {
      state.assets = assets
    },
    SET_SCHEME_PRODUCTS(state, products) {
      state.schemeProducts = products
    },
    SET_PLATFORM_DETAIL(state, detail) {
      state.platformDetail = detail
    }
  },

  actions: {
    async grabsecclNodes({ commit, state }, { platform }) {
      try {
        const rsp = await addonsAPI.secclNodes(platform)
        const allNodes = rsp.data.data
        commit('SET_ALL_SECCL_NODES', allNodes)

        const secclNodes = []
        const parentNodeIds = []
        allNodes.forEach((node) => {
          if (state.nodeIds.includes(node.id)) {
            parentNodeIds.push(node.parentNodeId)
            secclNodes.push(node)
          }
        })
        commit('SET_SECCL_NODES', secclNodes)

        const validParentNodes = allNodes
          .filter((node) => parentNodeIds.includes(node.id) && node.nodeType === 'Client Firm')
          .map((node) => node.id)
        commit('SET_VALID_PARENT_NODES', validParentNodes)
      } catch (error) {
        window.$nuxt.$emit(
          'notification',
          `There was an issue retrieving the nodes from ${platform} platform.`,
          'warning'
        )
      }
    },

    async grabNodes({ commit, dispatch }, { platform, assignedAdviserUuid }) {
      try {
        const rsp = await lookupsAPI.findLookup(`${platform}_node_mapping`, assignedAdviserUuid)
        const nodeIds = (rsp.data.data[0] && rsp.data.data[0].return_json) || []
        commit('SET_NODE_IDS', nodeIds)
        if (platform === 'seccl' || platform === 'soderberg') {
          await dispatch(`grabsecclNodes`, { platform })
        } else {
          await dispatch(`grab${platform}Nodes`, { platform })
        }
      } catch (error) {
        window.$nuxt.$emit(
          'notification',
          `There was an issue retrieving mapping for ${platform}.`,
          'warning'
        )
      }
    },

    async grabSchemeProducts({ state, commit }, { platform }) {
      let schemeProducts;
      if (state.schemeProducts.length > 0 && state.schemeProducts[0].platform === platform) {
        schemeProducts = state.schemeProducts;
      }

      if (schemeProducts === undefined || schemeProducts.length === 0) {
        const rsp = await addonsAPI.secclSchemaProducts(platform)
        schemeProducts = rsp.data.data;
      }

      if (schemeProducts !== state.schemeProducts) {
        commit('SET_SCHEME_PRODUCTS', schemeProducts);
      }

      return schemeProducts;
    },

    async grabModels({ commit, state }, { platform, item }) {
      commit('SET_MODELS_LOADING', true);

      const filterNodes = [...state.nodeIds, ...state.validParentNodes];

      const params = {
        'filter[wrapper_type]': item.request_data.wrapper_details.wrapper_type,
        ...(filterNodes.length > 0 && { 'filter[node_ids]': filterNodes.join(',') })
      };



      try {
        const rsp = await addonsAPI.getPlatformModels(platform, { params });
        commit('SET_MODELS', rsp.data.data);
      } catch (error) {
        window.$nuxt.$emit(
          'notification',
          `There was an issue retrieving the models from ${platform} platform.`,
          'warning'
        );
      } finally {
        commit('SET_MODELS_LOADING', false);
      }
    },

    async grabAssets({ commit, state }, { platform, searchTerm }) {
      try {
        const rsp = await addonsAPI.secclSearchAssets(platform, { search: searchTerm });
        const assets = rsp.data.data.filter((asset) => {
          if (asset.available_to_node_id.includes('0')) {
            return true;
          }
          return asset.node_id.some((nodeId) => state.nodeIds.includes(nodeId));
        });
        commit('SET_ASSETS', assets);
        return assets;
      } catch (error) {
        window.$nuxt.$emit(
          'notification',
          'There was an issue retrieving the assets from the platform. Try to narrow your search',
          'warning'
        );
        commit('SET_ASSETS', []);
      }
    },

    async grabPlatformDetail({ commit }, { platform }) {
      try {
        const rsp = await addonsAPI.getPlatformDetail(platform);
        commit('SET_PLATFORM_DETAIL', rsp.data.data);
      } catch (error) {
        window.$nuxt.$emit(
          'notification',
          `There was an issue retrieving the platform details for ${platform}.`,
          'warning'
        );
      }
    }
  },
};
